import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MensajeServices } from '../../Service/messages.services';
import { AplicacionServices } from '../../Service/aplicacion.services';
import { Alertas, TiposAlerta } from '../../recursos/alertas';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActualizacionViewModel } from '../../models/actualizacion-datos.viewmodel';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { Excel } from '../../recursos/excel';
import { mapActualizacionToExcelVM } from '../../mappers/actualizacion-excel.mapper';
import { ExcelExportConfig } from '../../models/export/excel-export.config';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

@Component({
  selector: 'app-admin-datos',
  templateUrl: './admin-datos.component.html',
  styleUrl: './admin-datos.component.css',
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})
export class AdminDatosComponent implements OnInit{
  Alertas: Alertas;
  @Input() Mensajes: any;
  @ViewChild('paginator') paginator: MatPaginator;
  dataSource: MatTableDataSource<ActualizacionViewModel>;
  displayedColumns: string[] = ['NombreCompleto', 'Identificacion', 'Correo', 'Celular', 'Direccion', 'EsPropietario', 'NumeroCuenta',
  'AutorizaInfo', 'NumeroCuenta', 'FechaCreacion', 'Telefono', 'AceptaTratDatosPer', 'RecibirFactElect', 'MatCatastral',
  'CodigoVerificacion', 'EmailVerificate', 'FechaVerification'];
  allReg: ActualizacionViewModel[];
   //Tooltips
   tooltip_fecha_desde: string;
   tooltip_fecha_hasta: string;
   tooltip_filtrar: string;
   tooltip_limpiar_filtros: string;
   tooltip_buscar: string;

  form = new FormGroup({
    fromDate: new FormControl(null, { validators: [Validators.required]}),
    toDate: new FormControl(null, { validators: [Validators.required]})
  });

  ngOnInit(): void {
    this.CargarRegistros();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.Mensajes && changes.Mensajes.currentValue)
      this.AsignarTooltips();
  }

  constructor(private _MensajeServices: MensajeServices, private _AplicacionServices: AplicacionServices) {
    this.Alertas = new Alertas(_MensajeServices);
  }

  AsignarTooltips(): void {
    this.tooltip_fecha_desde = this.Mensajes['tooltip_fecha_desde'];
    this.tooltip_fecha_hasta = this.Mensajes['tooltip_fecha_hasta'];
    this.tooltip_filtrar = this.Mensajes['tooltip_filtrar'];
    this.tooltip_limpiar_filtros = this.Mensajes['tooltip_limpiar_filtros'];
    this.tooltip_buscar = this.Mensajes['tooltip_buscar'];
  }

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  // }


  CargarRegistros() {
    setTimeout(() => {
      AplicacionServices.HabilitarCargador = true;
      this._AplicacionServices.ObtenerRegActDatos().then(data => {
        if (data.StatusCode === 200) {
         this.allReg = data.Data;
         this.asignarFuentaDatos(data.Data);
         AplicacionServices.HabilitarCargador = false;
        }
        else {
          AplicacionServices.HabilitarCargador = false;
          this.Alertas.MostrarAlertaConTexto('Error al cargar los datos', data.Message, TiposAlerta.error);
        }
      });
    }, 0);
  }

  asignarFuentaDatos(data: ActualizacionViewModel[]){
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
  }

  applyDateFilter() {
    // console.log(this.form);
    if (this.form.invalid) {
      return
    }
    this.dataSource.data = this.dataSource.data.filter(e=> new Date(e.FechaCreacion) >= this.form.value.fromDate && new Date(e.FechaCreacion) <= this.form.value.toDate);
  }

  clearDateInput() {
    this.form.reset();
    this.asignarFuentaDatos(this.allReg);
  }

  doFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Exportar() {
    AplicacionServices.HabilitarCargador = true;
    if (this.dataSource.data.length > 0){
      var ExcelManager = new Excel();
      ExcelManager.ObjectToExcelAndWrite(this.dataSource.data, 'Encabezados', 'Reporte.xlsx')
      AplicacionServices.HabilitarCargador = false;
    }
    else
      {
        AplicacionServices.HabilitarCargador = false;
        this.Alertas.MostrarAlerta('No hay datos', 'SinDatosReporte', TiposAlerta.error);
      }
  }

  ExportarCargueMasivo() {
    AplicacionServices.HabilitarCargador = true;
    if (this.dataSource.data.length > 0) {
      var ExcelManager = new Excel();
      const excelData = this.dataSource.data
        .map(a => mapActualizacionToExcelVM(a));

      const config: ExcelExportConfig = {
        fileName: 'REPORTE_ACTUALIZACION_DATOS.xlsx',
        sheetName: 'ACTUALIZACION',
        headers: [
          // =========================
          // GENERALES
          // =========================
          'CUENTA',
          'IND_ACT_DATOS_CLIENTE',
          'IND_ACT_DATOS_CONTACTO',
          'PROCESO',
          'MEDIO_SOLICITUD',
          'CLASIFICACION',
          'DETALLE_CLASIFICACION',

          // =========================
          // SOLICITANTE
          // =========================
          'TIPO_SOLICITANTE',
          'CLASE_SOLICITANTE',
          'TIPO_PERSONA_SOLICITANTE',
          'TIPO_DOCUMENTO_SOLICITANTE',
          'NUMERO_DOCUMENTO_SOLICITANTE',
          'EXPEDICION_DOCUMENTO_SOLICITANTE',
          'NOMBRE_1_SOLICITANTE',
          'NOMBRE_2_SOLICITANTE',
          'APELLIDO_1_SOLICITANTE',
          'APELLIDO_2_SOLICITANTE',
          'RAZON_SOCIAL_SOLICITANTE_APLICA_PARA_NIT',
          'TELEFONO_CONTACTO_SOLICITANTE',
          'CELULAR_SOLICITANTE',
          'DIRECCION_SOLICITANTE',
          'INF_ADICIONAL_DIRECCION_SOLICITANTE',
          'DEPARTAMENTO_SOLICITANTE',
          'MUNICIPIO_SOLICITANTE',
          'BARRIO_SOLICITANTE',
          'EMAIL_SOLICITANTE',
          'MEDIO_NOTIFICACION',
          'RADICADO',
          'TIPO_TRAMITE',
          'TIPO_RTA',
          'OBSERVACION',

          // =========================
          // CLIENTE
          // =========================
          'TIPO_PERSONA_CLIENTE',
          'TIPO_DOCUMENTO_CLIENTE',
          'NUMERO_DOCUMENTO_CLIENTE',
          'NOMBRE_1_CLIENTE',
          'NOMBRE_2_CLIENTE',
          'APELLIDO_1_CLIENTE',
          'APELLIDO_2_CLIENTE',
          'RAZON_SOCIAL_CLIENTE',
          'TELEFONO_CLIENTE',
          'CELULAR_CLIENTE',
          'DEPARTAMENTO_CLIENTE',
          'MUNICIPIO_CLIENTE',
          'BARRIO_CLIENTE',
          'DIRECCION_VIA_PRINCIPAL',
          'DIRECCION_DETALLE_CLIENTE',

          // =========================
          // VIA / DIRECCION
          // =========================
          'TIPO_VIA',
          'DETALLE_VIA',
          'PREFIJO_VIA',
          'NUMERO',
          'TIPO_VERTICAL',
          'NUMERO_VERTICAL',
          'TIPO_INTERIOR',
          'DETALLE_INTERIOR',
          'INTERIOR',
          'TIPO_PREDIO',
          'DESCRIPCION_PREDIO',

          // =========================
          // INFO PREDIAL / CLIENTE
          // =========================
          'INF_ADICIONAL_DIRECCION_CLIENTE',
          'EMAIL_CLIENTE',
          'TIPO_INFO_PREDIAL',
          'FICHA_CATASTRAL',
          'TIPO_DE_RECIBO',
          'AUTORIZA_USO_DATOS',

          // =========================
          // CONTACTO
          // =========================
          'TIPO_DE_CONTACTO',
          'TIPO_DOCUMENTO_CONTACTO',
          'NUMERO_DOCUMENTO_CONTACTO',
          'EXPEDICION_DOCUMENTO_CONTACTO',
          'NOMBRE_1_CONTACTO',
          'NOMBRE_2_CONTACTO',
          'APELLIDO_1_CONTACTO',
          'APELLIDO_2_CONTACTO',
          'RAZON_SOCIAL_CONTACTO',
          'DEPARTAMENTO_CONTACTO',
          'MUNICIPIO_CONTACTO',
          'DIRECCION_CONTACTO',
          'EMAIL_CONTACTO',
          'CELULAR_CONTACTO_1',
          'CELULAR_CONTACTO_2',
          'TELEFONO_FIJO_CONTACTO',
          'EXTENSION_TELEFONO_FIJO_CONTACTO_1',
          'TELEFONO_FIJO_CONTACTO_2',
          'EXTENSION_TELEFONO_FIJO_CONTACTO_2',
          'TELEFONO_FIJO_CONTACTO_3',
          'EXTENSION_TELEFONO_FIJO_CONTACTO_3'
        ]
      };

      ExcelManager.exportWithConfig(excelData, config);
      AplicacionServices.HabilitarCargador = false;
    }
    else {
      AplicacionServices.HabilitarCargador = false;
      this.Alertas.MostrarAlerta('No hay datos', 'SinDatosReporte', TiposAlerta.error);
    }
  }
}
